/* CraftRoot theme JS */
(function () {
  'use strict';
  var CR = window.CR || { freeShip: 50, money: '€' };
  var FREE = (CR.freeShip || 50) * 100;

  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  var LOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:18px;height:18px;flex:0 0 auto"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
  var SHIELD = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3Z"/><path d="m9 12 2 2 4-4"/></svg>';

  /* ---------- Upsell styles (drawer + cart page) ---------- */
  (function () {
    var css = '.cr-up{margin-top:14px}.cr-up__title{font-size:1rem;margin:0 0 10px;font-weight:700}.cr-up__grid{display:flex;flex-direction:column;gap:10px}.cr-up__card{display:flex;align-items:center;gap:12px;background:var(--green-50,#E3F1EF);border-radius:14px;padding:10px}.cr-up__card img{width:54px;height:54px;object-fit:cover;border-radius:10px;background:#fff;flex:0 0 auto}.cr-up__info{flex:1 1 auto;min-width:0}.cr-up__name{font-size:.86rem;font-weight:600;color:var(--ink);text-decoration:none;line-height:1.25;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.cr-up__price{font-size:.85rem;margin-top:3px}.cr-up__price s{opacity:.55;margin-right:4px;font-weight:400}.cr-up__price strong{color:var(--green-800,#0d7868)}.cr-up__add{flex:0 0 auto;border:1.5px solid var(--green-500,#117270);background:#fff;color:var(--green-500,#117270);border-radius:10px;padding:8px 12px;font-size:.8rem;font-weight:600;cursor:pointer;white-space:nowrap}.cr-up__add:hover{background:var(--green-500,#117270);color:#fff}.cr-up__protect{display:flex;align-items:center;gap:12px;border:1.5px dashed var(--green-500,#117270);border-radius:14px;padding:12px;margin-top:14px}.cr-up__protect.is-on{background:var(--green-50,#E3F1EF);border-style:solid}.cr-up__protect-ico{flex:0 0 auto;color:var(--green-500,#117270)}.cr-up__protect-ico svg{width:30px;height:30px}.cr-up__protect-txt{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:2px}.cr-up__protect-txt strong{font-size:.88rem}.cr-up__protect-txt span{font-size:.78rem;color:#5b6b67;line-height:1.35}.cr-up__protect-btn{flex:0 0 auto;border:none;background:var(--green-500,#117270);color:#fff;border-radius:10px;padding:9px 13px;font-size:.8rem;font-weight:600;cursor:pointer;white-space:nowrap}.cr-up__protect-btn.is-added{background:#fff;color:var(--green-800,#0d7868);border:1.5px solid var(--green-500,#117270)}.cr-sav{display:flex;justify-content:space-between;font-size:.86rem;color:var(--green-500,#117270);font-weight:600;margin-bottom:4px}.cr-sav--code{color:var(--green-800,#0d7868)}.drawer__pay{margin-top:14px;display:flex;flex-direction:column;align-items:center;gap:9px}.drawer__pay-ico{display:flex;flex-wrap:wrap;gap:5px;justify-content:center}.drawer__pay-ico svg{height:22px;width:auto;border-radius:3px}.drawer__wwk{display:inline-flex;align-items:center;gap:6px;font-size:.74rem;color:var(--ink);text-decoration:none;white-space:nowrap}.drawer__wwk img{height:16px;width:auto}.drawer__wwk:hover span{text-decoration:underline}';
    var s = document.createElement('style');
    s.textContent = css;
    document.head.appendChild(s);
  })();

  /* ---------- Toast ---------- */
  var toastEl = $('#toast'), toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  }

  /* ---------- Drawer ---------- */
  var drawer = $('#cart-drawer'), overlay = $('#drawer-overlay');
  function openDrawer() { if (drawer) { drawer.classList.add('open'); overlay.classList.add('open'); document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('open'); overlay.classList.remove('open'); document.body.style.overflow = ''; } }
  if (overlay) overlay.addEventListener('click', closeDrawer);
  var dc = $('#drawer-close'); if (dc) dc.addEventListener('click', closeDrawer);
  var ct = $('#cart-toggle'); if (ct) ct.addEventListener('click', function () { refreshCart(true); });

  /* ---------- Cart count ---------- */
  function setCount(n) {
    var el = $('#cart-count');
    if (!el) return;
    el.textContent = n;
    if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
  }

  /* ---------- Smart upsell helpers ---------- */
  function cartInfo(cart) {
    var types = { ketting: false, snoei: false, blad: false }, handles = {};
    cart.items.forEach(function (it) {
      handles[it.handle] = true;
      var t = (it.product_type || '').toLowerCase();
      if (t.indexOf('set') > -1) { types.ketting = true; types.snoei = true; }
      if (t.indexOf('kettingzaag') > -1) types.ketting = true;
      if (t.indexOf('snoeischaar') > -1) types.snoei = true;
      if (t.indexOf('bladblazer') > -1) types.blad = true;
    });
    return { types: types, handles: handles };
  }
  function recHandles(types) {
    var rec = [];
    if (types.ketting) rec.push('craftroot-zaagketting-6-inch-vervanging');
    if (types.snoei) rec.push('craftroot-vervangende-messenset-snoeischaar');
    if (types.ketting && !types.snoei) rec.push('elektrische-snoeischaar-2x-4-0ah-accus-opbergkoffer');
    if (types.snoei && !types.ketting) rec.push('mini-kettingzaag-pro-brushless-met-koffer-2-4ah-accu');
    if (!types.blad) rec.push('craftroot-accu-bladblazer-pro');
    if (rec.length === 0) rec = ['mini-kettingzaag-pro-brushless-met-koffer-2-4ah-accu', 'elektrische-snoeischaar-2x-4-0ah-accus-opbergkoffer', 'craftroot-accu-bladblazer-pro'];
    return rec;
  }
  function upsellHtml(cart) {
    var data = (window.CR && CR.upsell) || {};
    var info = cartInfo(cart);
    var rec = recHandles(info.types);
    var cards = '', n = 0, max = 2;
    for (var i = 0; i < rec.length && n < max; i++) {
      var h = rec[i];
      if (info.handles[h]) continue;
      var p = data[h];
      if (!p) continue;
      var price = (p.compare && p.compare > p.price) ? '<s>' + money(p.compare) + '</s> <strong>' + money(p.price) + '</strong>' : '<strong>' + money(p.price) + '</strong>';
      cards += '<div class="cr-up__card"><img src="' + p.img + '" alt=""><div class="cr-up__info"><a href="' + p.url + '" class="cr-up__name">' + p.title + '</a><div class="cr-up__price">' + price + '</div></div><button type="button" class="cr-up__add" data-drawer-add="' + p.variant + '">+ Toevoegen</button></div>';
      n++;
    }
    if (n === 0) return '';
    return '<div class="cr-up"><h3 class="cr-up__title">Maak je set compleet</h3><div class="cr-up__grid">' + cards + '</div></div>';
  }
  function protectHtml(cart) {
    var pv = (window.CR && CR.protectVariant) || 0;
    var pin = null;
    cart.items.forEach(function (it) { if (it.variant_id == pv) pin = it.key; });
    var price = money((window.CR && CR.protectPrice) || 295);
    var btn = pin
      ? '<button type="button" class="cr-up__protect-btn is-added" data-drawer-rm="' + pin + '">Toegevoegd ✓</button>'
      : '<button type="button" class="cr-up__protect-btn" data-drawer-add="' + pv + '">Toevoegen</button>';
    return '<div class="cr-up__protect' + (pin ? ' is-on' : '') + '"><div class="cr-up__protect-ico">' + SHIELD + '</div><div class="cr-up__protect-txt"><strong>Verzekerd verzenden · ' + price + '</strong><span>Bij schade of verlies ontvang je direct een nieuw product, zonder gedoe of wachttijd.</span></div>' + btn + '</div>';
  }
  function savingsHtml(cart) {
    var cmap = (window.CR && CR.compareAt) || {};
    var compareSav = 0;
    cart.items.forEach(function (it) {
      var c = cmap[it.variant_id];
      if (c && c > it.price) compareSav += (c - it.price) * it.quantity;
    });
    var html = '';
    if (compareSav > 0) html += '<div class="cr-sav"><span>Je bespaart</span><span>' + money(compareSav) + '</span></div>';
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      html += '<div class="cr-sav cr-sav--code"><span>' + d.title + '</span><span>−' + money(d.total_allocated_amount) + '</span></div>';
    });
    return html;
  }
  function ensureFooterExtras() {
    var foot = $('#drawer-foot');
    if (!foot) return;
    if (!$('#drawer-savings', foot)) {
      var sav = document.createElement('div');
      sav.id = 'drawer-savings';
      var total = $('.cart-summary__total', foot);
      if (total) foot.insertBefore(sav, total); else foot.appendChild(sav);
    }
    var co = foot.querySelector('a[href="/checkout"], a[href*="/checkout"]');
    if (co && !co.querySelector('svg')) {
      co.style.display = 'flex';
      co.style.alignItems = 'center';
      co.style.justifyContent = 'center';
      co.style.gap = '9px';
      co.insertAdjacentHTML('afterbegin', LOCK);
    }
    if (!$('#drawer-pay', foot)) {
      var pay = document.createElement('div');
      pay.id = 'drawer-pay';
      pay.className = 'drawer__pay';
      pay.innerHTML = '<div class="drawer__pay-ico">' + ((window.CR && CR.payHtml) || '') + '</div>' +
        '<a href="https://www.webwinkelkeur.nl/webshop/CraftRoot_1226016" target="_blank" rel="noopener" class="drawer__wwk"><img src="' + ((window.CR && CR.wwkUrl) || '') + '" alt="WebwinkelKeur"><span>Beschermd door WebwinkelKeur</span></a>';
      foot.appendChild(pay);
    }
  }

  /* ---------- Render drawer ---------- */
  function renderDrawer(cart) {
    var body = $('#drawer-body'), foot = $('#drawer-foot');
    if (!body) return;
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="drawer__empty"><p>Je winkelwagen is nog leeg.</p><a href="' + (CR.cartUrl || '/cart') + '" class="btn btn--ghost">Verder winkelen</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    var html = '';
    cart.items.forEach(function (it) {
      if (it.variant_id == ((window.CR && CR.protectVariant) || 0)) return;
      html += '<div class="drawer-line" data-key="' + it.key + '">' +
        '<a href="' + it.url + '"><img src="' + (it.image ? it.image : '') + '" alt=""></a>' +
        '<div><div class="drawer-line__t">' + it.product_title + '</div>' +
        '<div class="muted" style="font-size:.84rem">' + it.quantity + ' × ' + money(it.final_price) + '</div>' +
        '<button class="drawer-line__rm" data-rm="' + it.key + '">Verwijderen</button></div>' +
        '<div class="price" style="font-size:1rem">' + money(it.final_line_price) + '</div></div>';
    });
    body.innerHTML = html + protectHtml(cart) + upsellHtml(cart);
    if (foot) {
      foot.hidden = false;
      ensureFooterExtras();
      $('#drawer-total').textContent = money(cart.total_price);
      var savEl = $('#drawer-savings'); if (savEl) savEl.innerHTML = savingsHtml(cart);
      var remain = FREE - cart.total_price;
      var bar = $('#drawer-bar'), ship = $('#drawer-ship');
      if (remain > 0) {
        ship.innerHTML = 'Nog <strong>' + money(remain) + '</strong> tot gratis verzending';
        bar.style.width = Math.min(100, (cart.total_price / FREE) * 100) + '%';
      } else {
        ship.innerHTML = 'Je hebt <strong>gratis verzending</strong>!';
        bar.style.width = '100%';
      }
    }
    $all('[data-rm]', body).forEach(function (b) {
      b.addEventListener('click', function () { changeQty(b.getAttribute('data-rm'), 0); });
    });
    $all('[data-drawer-add]', body).forEach(function (b) {
      b.addEventListener('click', function () { addToCart(b.getAttribute('data-drawer-add'), 1, b); });
    });
    $all('[data-drawer-rm]', body).forEach(function (b) {
      b.addEventListener('click', function () { changeQty(b.getAttribute('data-drawer-rm'), 0); });
    });
  }

  function refreshCart(show) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); renderDrawer(cart); if (show) openDrawer(); })
      .catch(function () { if (show) window.location.href = CR.cartUrl || '/cart'; });
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); renderDrawer(cart); })
      .catch(function () {});
  }

  function addToCart(id, qty, btn) {
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Bezig…'; }
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      toast('Toegevoegd aan je winkelwagen');
      refreshCart(true);
    }).catch(function () {
      toast('Niet gelukt — probeer opnieuw');
    }).finally(function () {
      if (btn) { btn.disabled = false; btn.innerHTML = original; }
    });
  }

  /* ---------- Quick-add (cards) ---------- */
  $all('[data-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (id) addToCart(id, 1, btn);
    });
  });

  /* ---------- Product form ---------- */
  var pform = $('[data-product-form]');
  if (pform) {
    pform.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = pform.querySelector('[name="id"]').value;
      var qEl = pform.querySelector('[name="quantity"]');
      var qty = qEl ? parseInt(qEl.value, 10) || 1 : 1;
      addToCart(id, qty, pform.querySelector('[data-atc]'));
    });
    // qty steppers
    $all('[data-qty]', pform).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = pform.querySelector('[name="quantity"]');
        var val = parseInt(input.value, 10) || 1;
        val += b.getAttribute('data-qty') === '+' ? 1 : -1;
        if (val < 1) val = 1;
        input.value = val;
      });
    });
  }

  /* ---------- Sticky ATC ---------- */
  var sticky = $('#sticky-atc-btn');
  if (sticky && pform) {
    sticky.addEventListener('click', function () {
      var id = pform.querySelector('[name="id"]').value;
      var qEl = pform.querySelector('[name="quantity"]');
      addToCart(id, qEl ? parseInt(qEl.value, 10) || 1 : 1, sticky);
    });
  }

  /* ---------- Gallery ---------- */
  var gmain = $('#gallery-main');
  if (gmain) {
    $all('.gallery__thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        var src = b.getAttribute('data-thumb');
        if (src) gmain.src = src;
        $all('.gallery__thumbs button').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
      });
    });
  }

  /* ---------- Mobile nav ---------- */
  var mnav = $('#mobile-nav');
  var burger = $('#burger'); if (burger) burger.addEventListener('click', function () { mnav.classList.add('open'); document.body.style.overflow = 'hidden'; });
  var mclose = $('#mobile-nav-close'); if (mclose) mclose.addEventListener('click', function () { mnav.classList.remove('open'); document.body.style.overflow = ''; });
  if (mnav) $all('a', mnav).forEach(function (a) { a.addEventListener('click', function () { mnav.classList.remove('open'); document.body.style.overflow = ''; }); });

  /* ---------- Announcement: static, no rotation ---------- */

  /* ---------- Urgency / social proof numbers ---------- */
  (function () {
    var v = document.querySelector('[data-viewers]'), o = document.querySelector('[data-orders]');
    if (v) v.textContent = 7 + Math.floor(Math.random() * 16);
    if (o) o.textContent = 4 + Math.floor(Math.random() * 11);
  })();

  /* ---------- Predictive search (live suggesties) ---------- */
  var hs = $('#hsearch'), suggest = $('#search-suggest'), stimer;
  if (hs && suggest) {
    hs.addEventListener('input', function () {
      var q = hs.value.trim();
      clearTimeout(stimer);
      if (q.length < 2) { suggest.hidden = true; return; }
      stimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!ps.length) { suggest.innerHTML = '<div class="ss-empty">Geen resultaten voor &ldquo;' + q + '&rdquo;</div>'; suggest.hidden = false; return; }
            suggest.innerHTML = ps.map(function (p) {
              var img = (p.featured_image && p.featured_image.url) ? '<img src="' + p.featured_image.url + '" alt="">' : '';
              return '<a href="' + p.url + '">' + img + '<span>' + p.title + '</span></a>';
            }).join('');
            suggest.hidden = false;
          }).catch(function () { suggest.hidden = true; });
      }, 220);
    });
    document.addEventListener('click', function (e) {
      if (!suggest.contains(e.target) && e.target !== hs) suggest.hidden = true;
    });
  }

  /* init */
  refreshCart(false);
})();
